module.exports = __webpack_public_path__ + "img/hys-4.4c2e47af.webp";